import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const pageKeys: Record<string, { title: string; description: string }> = {
  "/": { title: "home.title", description: "home.intro" },
  "/music": { title: "music.title", description: "music.intro" },
  "/music/baltiptsy": { title: "baltiptsy.title", description: "baltiptsy.subtitle" },
  "/culture": { title: "culture.title", description: "culture.subtitle" },
  "/history": { title: "history.title", description: "history.subtitle" },
  "/tlahuitoltepec": { title: "territory.title", description: "territory.subtitle" },
  "/gallery": { title: "gallery.title", description: "gallery.subtitle" },
  "/epk": { title: "navbar.epk", description: "epk.aboutText" },
  "/hiring": { title: "hiring.title", description: "hiring.text" },
  "/privacy": { title: "privacy.title", description: "privacy.analyticsText" }
};

const setMeta = (selector: string, attribute: "name" | "property", key: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) { element = document.createElement("meta"); element.setAttribute(attribute, key); document.head.appendChild(element); }
  element.content = content;
};

const SeoManager = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const page = pageKeys[pathname];
    const isKnown = Boolean(page);
    const title = isKnown ? `${t(page.title)} · Kujipy` : `${t("notFound.title")} · Kujipy`;
    const description = isKnown ? t(page.description) : t("notFound.text");
    const canonicalUrl = `https://www.kujipy.com${pathname === "/" ? "/" : pathname}`;
    document.title = title;
    document.documentElement.lang = i18n.language.startsWith("en") ? "en" : "es";
    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[name="robots"]', "name", "robots", isKnown ? "index, follow" : "noindex, follow");
    setMeta('meta[property="og:title"]', "property", "og:title", title);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", canonicalUrl);
    const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.href = canonicalUrl;
  }, [pathname, i18n.language, t]);

  return null;
};

export default SeoManager;
